(() => {
  const bindVideoModal = root => {
    if (window.DreoVideoModal) {
      const sectionEl = root.closest('.shopify-section') || root;
      window.DreoVideoModal.bind(sectionEl);
    }
  };

  const initRoot = root => {
    if (root.dataset.flowsSliderInit === 'true') return;

    bindVideoModal(root);

    const sliderWrap = root.querySelector('.flows-slider');
    const markReady = () => {
      root.classList.add('is-ready');
      if (sliderWrap) sliderWrap.classList.add('is-ready');
    };

    const revealSlider = swiper => {
      if (swiper) {
        swiper.update();
        swiper.slideTo(swiper.activeIndex, 0, false);
      }
      requestAnimationFrame(() => {
        if (swiper) swiper.update();
        requestAnimationFrame(markReady);
      });
    };

    const swiperEl = root.querySelector('[data-flows-swiper]');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    const slides = swiperEl.querySelectorAll('.swiper-slide');
    if (!slides.length) {
      markReady();
      return;
    }

    const layout = root.dataset.layout || 'container';
    const controlsEl = root.querySelector('[data-lp-swiper-bar-controls]');
    const indicatorsEl = controlsEl ? controlsEl.querySelector('[data-lp-sbc-pagination]') : null;
    const prevBtn = controlsEl ? controlsEl.querySelector('[data-lp-sbc-prev]') : null;
    const nextBtn = controlsEl ? controlsEl.querySelector('[data-lp-sbc-next]') : null;
    const autoplayEnabled = root.dataset.autoplay === 'true';
    const autoplayDelay = Number(root.dataset.autoplayDelay || 5000);
    const slideCount = slides.length;
    const enableLoop = slideCount > 1;

    const config = {
      slidesPerView: 'auto',
      centeredSlides: layout === 'container',
      spaceBetween: layout === 'card' ? 24 : 16,
      speed: 600,
      loop: enableLoop && slideCount > 1,
      watchOverflow: true,
      keyboard: { enabled: true, onlyInViewport: true },
      a11y: { enabled: true },
      on: {
        init(swiper) {
          revealSlider(swiper);
        },
      },
    };

    if (layout === 'container') {
      config.watchSlidesProgress = true;
    }

    if (layout === 'card' && window.matchMedia('(min-width: 1024px)').matches) {
      config.spaceBetween = 60;
      config.centeredSlides = false;
    }

    if (prevBtn && nextBtn) {
      config.navigation = {
        prevEl: prevBtn,
        nextEl: nextBtn,
        disabledClass: 'swiper-button-disabled',
      };
    }

    if (indicatorsEl) {
      config.pagination = {
        el: indicatorsEl,
        clickable: true,
        type: 'bullets',
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active',
      };
    }

    if (autoplayEnabled && slideCount > 1) {
      config.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    const scheduleSwiperUpdate = () => {
      if (!root._flowsSwiper) return;
      requestAnimationFrame(() => {
        if (root._flowsSwiper) root._flowsSwiper.update();
      });
    };

    try {
      const swiper = new Swiper(swiperEl, config);
      root.dataset.flowsSliderInit = 'true';
      root._flowsSwiper = swiper;

      if (layout === 'card') {
        swiperEl.querySelectorAll('.flows-slider__card-media img').forEach(img => {
          if (img.complete) return;
          img.addEventListener('load', scheduleSwiperUpdate, { once: true });
        });
      }
    } catch (error) {
      markReady();
      console.error('[lp-flows-technical-slider] Swiper init failed:', error);
      return;
    }

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (!root._flowsSwiper) return;
        const isCardDesktop = layout === 'card' && window.matchMedia('(min-width: 1024px)').matches;
        root._flowsSwiper.params.centeredSlides = layout === 'container' ? true : !isCardDesktop;
        root._flowsSwiper.params.spaceBetween = layout === 'card' ? (isCardDesktop ? 60 : 24) : 16;
        root._flowsSwiper.update();
      }, 120);
    });
  };

  const boot = () => {
    document.querySelectorAll('[data-flows-slider]').forEach(initRoot);
  };

  const bootWithFallback = () => {
    boot();
    window.setTimeout(() => {
      document.querySelectorAll('[data-flows-slider]:not(.is-ready)').forEach(root => {
        const sliderWrap = root.querySelector('.flows-slider');
        root.classList.add('is-ready');
        if (sliderWrap) sliderWrap.classList.add('is-ready');
      });
    }, 2000);
  };

  if (typeof Swiper === 'undefined') {
    document.addEventListener('DOMContentLoaded', () => {
      const waitForSwiper = () => {
        if (typeof Swiper === 'undefined') {
          setTimeout(waitForSwiper, 50);
          return;
        }
        bootWithFallback();
      };
      waitForSwiper();
    });
  } else {
    document.addEventListener('DOMContentLoaded', bootWithFallback);
  }

  document.addEventListener('shopify:section:load', event => {
    const section = event.target.querySelector('[data-flows-slider]');
    if (section) {
      delete section.dataset.flowsSliderInit;
      initRoot(section);
      return;
    }

    const sectionEl = event.target.closest('.shopify-section') || event.target;
    if (sectionEl && sectionEl.querySelector('[data-video-trigger="true"]')) {
      bindVideoModal(sectionEl);
    }
  });
})();
